const Routes = Object.freeze({
  DASHBOARD: '/',
  LOGIN: '/login',
  REGISTER: '/register',
  FORGOT_PASSWORD: '/forgot-password',
  RESET_PASSWORD: '/reset-password',
  CONFIRM_EMAIL: '/confirm-email',
  PAYMENT_SELECT: '/payment-select',
  DATA_TABLE: '/data-table',
  INPUTS: '/inputs',
  SANDBOX: '/sandbox',
  EMAIL_TEMPLATE: '/email-template',
  LESSON_DETAILS: '/details/:id',
  QUIZ: '/quiz/:lessonId',
  // Admin routes
  ADMIN_DASHBOARD: '/admin',
  ADMIN_USERS: '/admin/users',
  ADMIN_LESSONS: '/admin/lessons',
  ADMIN_ANALYTICS: '/admin/analytics',
  ADMIN_ADD_REGION: '/admin/add-region',
  ADMIN_UPLOAD_CONTENT: '/admin/upload-content',
  ADMIN_UPLOAD_LESSON: '/admin/upload-lesson',
  ADMIN_EDIT_LESSON: '/admin/edit-lesson/:id',
  ADMIN_LESSON_DETAILS: '/admin/details/:id',
  ADMIN_QUIZ: '/admin/quiz/:lessonId'
} as const);

export default Routes;

export type AvailableRoutes = (typeof Routes)[keyof typeof Routes];
